import { render } from "./RombelView.vue?vue&type=template&id=2e634bc8"
import script from "./RombelView.vue?vue&type=script&lang=js"
export * from "./RombelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__